import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { MenuItem, SelectItem, TreeNode, MessageService } from 'primeng/api';
import { CampaignController } from '@Workspace/_generated/services';
import { eEntityStatus, eCampaignStatus, eStandardCampaginChannel, eChannel, eChannelType, eFileType, eUserRole, eVideoType, eCallToAction, eCreativeTheme, eCreativeThemeName } from '@Workspace/_generated/enums';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { EnumStringPipe } from '@Workspace/pipes';
import { FileUpload } from '../../../../../shared-core/components/file-upload/file-upload.component';
import { CartItemService } from '../../../../../shared-core/components/card-item/card-item.service';
import { ICreativeAssetDto, ICreativeDto, IUploadPayloadModelDto, IUpload, IFacebookDetailsJson, IFacebookNewsFeedDetailJson, IInStreamVideoJson, IDetailJson, ISelectItem, IDetailSocialCampaignJson, IEnumDataAttribute } from '@Workspace/_generated/interfaces';
import { IBaseCampaignDto } from '@Workspace/_generated/interfaces';
import { FileUploadService } from '../../../../services/file-upload.service';
import { Functions, LookUps, Constants } from '@Workspace/common';
import { AuthService } from '@Workspace/auth';
import { CampaignService } from '../../../../../mogo/services/campaign.service';
import { constants } from 'os';

@Component({
    selector: 'social-general',
    templateUrl: './social-general.component.html',
    styleUrls: ['./social-general.component.scss']
})
export class SocialGeneralComponent implements OnInit, OnDestroy {
    constructor(
        public campaignController: CampaignController,
        public messageService: MessageService,
        public router: Router,
        private cardItemService: CartItemService,
        private activatedRoute: ActivatedRoute,
        private fileUploadService: FileUploadService,
        private authService: AuthService,
        private campaignService: CampaignService
    ) { }

     @Input() creative: ICreativeDto;
     @Input() reviewPage: boolean = false;
     @Input() isApprove: boolean = false;
     @Input() campaign: IBaseCampaignDto;
     @Input() socialFlexibleCampaign: ICreativeDto[];
     @Input() creativeTypeDD: SelectItem[];
     @Output() selectedCampaignTypeChange = new EventEmitter<number>();

    @Output() Basecampaign: EventEmitter<IBaseCampaignDto> = new EventEmitter();
    @Output() onCreativetDelete: EventEmitter<any> = new EventEmitter();
    @Output() openPreviewEvent: EventEmitter<any> = new EventEmitter();
     ngUnsubscribe = new Subject();
    currentUser = this.authService.userSettings;
    enumCampaignStatus = eCampaignStatus;
    enumStandardCampaginChannel = eStandardCampaginChannel;

    ngOnInit() {
        if (this.creative.detailSocialCampaignJson == null) {
            this.creative.detailSocialCampaignJson = {} as IDetailSocialCampaignJson;
            
        }
    }

    get campaignTypeOptions(): SelectItem[] {
        return (this.creative?.primaryCreativeTypeId === eStandardCampaginChannel.Content && (this.creative.creativeTypeId === eStandardCampaginChannel.Content || this.creative.creativeTypeId === eStandardCampaginChannel.Paid_support))
            ? this.creativeTypeDD?.filter(option => option.value === eStandardCampaginChannel.Content || option.value === eStandardCampaginChannel.Paid_support)
            : this.creativeTypeDD;
    }

    private enumMapToArray(map: Map<number, IEnumDataAttribute>): any[] {
        let result: any[] = [];
        let otherItem: any = null;

        map.forEach(((enumDataAttr, key) => {
            if (key!=0){
                const item = {
                    label: enumDataAttr.name,
                    value: key,
                    quantity: 0
                };

                if (enumDataAttr.name == "Other") {
                    otherItem = item;
                } else {
                    result.push(item);
                }
            }
        }
        ));

        result.sort((a, b) => a.label.localeCompare(b.label));

        if (otherItem) {
            result.push(otherItem);
        }
        return result;
    }


    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    onPostLocationChange(): void {
        if (!this.creative.detailSocialCampaignJson.postLocation?.includes('9')) {
            this.creative.detailSocialCampaignJson.otherPostLocation = "";
        }
    }

}
